import { useEffect, useState } from 'react';
import { navLinks } from '@/mocks/drama';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const solid = scrolled || open;

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
        solid
          ? 'bg-background-50/95 backdrop-blur border-b border-background-200'
          : 'bg-transparent border-b border-transparent'
      }`}
    >
      <div className="mx-auto flex h-16 md:h-20 max-w-7xl items-center justify-between px-4 md:px-8">
        <a href="#top" className="flex items-center gap-3 cursor-pointer">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 font-heading text-lg font-bold text-background-50">
            继
          </span>
          <span className="flex flex-col leading-none">
            <span
              className={`font-heading text-base font-bold tracking-wide ${
                solid ? 'text-foreground-950' : 'text-background-50'
              }`}
            >
              继母的诱惑
            </span>
            <span
              className={`mt-0.5 text-[11px] font-label tracking-[0.2em] ${
                solid ? 'text-foreground-500' : 'text-background-200'
              }`}
            >
              剧情解析
            </span>
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-1">
          {navLinks.map((link) => (
            <a
              key={link.id}
              href={`#${link.id}`}
              className={`cursor-pointer whitespace-nowrap rounded-md px-3 py-2 text-sm font-label transition-colors ${
                solid
                  ? 'text-foreground-700 hover:bg-background-100 hover:text-primary-600'
                  : 'text-background-100 hover:text-background-50'
              }`}
            >
              {link.label}
            </a>
          ))}
        </nav>

        <button
          type="button"
          aria-label="打开菜单"
          onClick={() => setOpen((v) => !v)}
          className={`md:hidden flex h-10 w-10 items-center justify-center rounded-md cursor-pointer transition-colors ${
            solid
              ? 'text-foreground-900 hover:bg-background-100'
              : 'text-background-50 hover:bg-white/10'
          }`}
        >
          <i className={open ? 'ri-close-line text-2xl' : 'ri-menu-line text-2xl'}></i>
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-background-200 bg-background-50 px-4 pb-4 pt-2">
          <nav className="flex flex-col">
            {navLinks.map((link) => (
              <a
                key={link.id}
                href={`#${link.id}`}
                onClick={() => setOpen(false)}
                className="cursor-pointer whitespace-nowrap rounded-md px-3 py-3 text-sm font-label text-foreground-700 hover:bg-background-100 hover:text-primary-600"
              >
                {link.label}
              </a>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}